import React, { memo } from 'react'
import { Text } from '@pancakeswap/uikit'
import { MiningItem } from './style'

interface PropType {
  title: string
  isError?: boolean
  regexTitle?: string
  isShowStart?: boolean
  children?: React.ReactNode
}

function App(props: PropType) {
  const { title, regexTitle, isShowStart = false, isError = false } = props

  return (
    <MiningItem>
      <div className={`${isError ? 'errorContent' : ''}`}>
        <Text mb="6px" className={`${isShowStart ? 'start' : ''}`} bold>
          {title}
        </Text>
        {props.children}
        <Text color="red" fontSize="14px" height="20px">
          {isError ? regexTitle : ''}
        </Text>
      </div>
    </MiningItem>
  )
}

export default memo(App)
